import { createStyles, Theme } from '@material-ui/core/styles';

const standardLayoutStyles = ({ spacing, colors, borders }: Theme) => createStyles({
  tooltip: {
    maxWidth: 800,
    marginTop: spacing(0.5),
    background: colors.pageElements.tooltip.fill,
    color: colors.pageElements.tooltip.text,
    padding: spacing(2),
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: colors.pageElements.tooltip.stroke,
    borderRadius: borders.radiusZero,
  },
});

export default standardLayoutStyles;
